<template>
  <Dashboard>
    <router-view />
  </Dashboard>
</template>

<script>
  import Dashboard from './admin/Dashboard'

  export default {
    components: {
      Dashboard,
    },
  }
</script>

<style lang="scss">
  @import "@/styles/_admin.scss";
</style>

